import React from "react";
import { Page } from "../../layouts/Page";
import {
  CashOutOverview,
  CashOutPageHeader,
  CashOutDialog,
  TopOffDialog
} from "../../molecules/CashOutOverview";
import { Spinner } from "@blueprintjs/core";
import useOrderCashOutReport from "./useOrderCashOutReport";
import { getColumnWidth } from "./helpers";
import useCashOutOverview from "../../molecules/CashOutOverview/CashOutOverviewHooks";

function OrderCashOut() {
  const cashOutProps = useOrderCashOutReport({});
  const { loading, overviewReport } = cashOutProps;
  const cashOutOverviewProps = useCashOutOverview(overviewReport);

  return (
    <Page title="Cash Out" flex>
      {loading && <Spinner />}
      {!loading && (
        <>
          <CashOutPageHeader {...cashOutProps} {...cashOutOverviewProps} />
          <CashOutDialog {...cashOutProps} {...cashOutOverviewProps} />
          <TopOffDialog {...cashOutProps} {...cashOutOverviewProps} />
          <CashOutOverview
            {...cashOutProps}
            {...cashOutOverviewProps}
            getColumnWidth={getColumnWidth}
          />
        </>
      )}
    </Page>
  );
}

export default OrderCashOut;
